<template>
  <div class="banner" v-if="list&&list.length">
    <van-swipe
      style="height: 30px"
      vertical
      :autoplay="3000"
      :show-indicators="false"
      :touchable="false"
    >
      <van-swipe-item v-for="item in list" :key="item.id">
        <div class="wrap">
          <span>{{ item.receiverName }}</span>
          <span>{{ item.phone }}</span>
          <span>已下单</span>
          <span>{{ item.buyCount }}</span>
          <span>份</span>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { doSecKill, getSecOrderInfo, getRecordList } from "@/api/home";

export default {
  data() {
    return {
      list: [],
      // mapState,
    };
  },
  // computed: {
  //   ...mapState(["nthUserInfo"]),
  // },
  methods: {
    async getRecordList() {
      const { data: res } = await getRecordList();
      console.log(res);
      if (res.code == 200) {
        this.list = res.data;
      }
    },
  },
  mounted() {
    this.getRecordList();
  },
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  margin-top: -30px;
  height: 80px;

  background: #ff991d;
  padding-top: 40px;


  
  .wrap {
    color: #fff;

    text-align: center;
    // line-height: 60px;
    span {
      margin: 0 4px;
    }
  }
}

// //组件

// .van-swipe {
//   border-radius: 4px;
// }

// .wrapper {
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;

//   justify-content: center;
//   align-items: center;
//   .img-wrap {
//     width: 50%;
//     img {
//       width: 100%;
//     }
//   }
// }
</style>
